import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { CatalogQuery } from './catalog.query';

@Injectable({ providedIn: 'root' })
export class CatalogAclService extends AbstractFeatureAclService<Y42FeatureType.Catalog> {
  constructor(query: CatalogQuery) {
    super({
      featureType: Y42FeatureType.Catalog,
      query,
    });
  }
}
